import Swal from "sweetalert2";
export const handleCarUpdate = async (
  carId,
  data,
  {
    fetchData,
    setUpdatingCarId,
    setEditingCar,
    cars,
    rentals,
    coupons,
    contact,
    drivers,
    tours,
    tourBookings,
    employeeService,
    setCarsData,
    setRentalsData,
    setCouponsData,
    setTransfersData,
    setDriversData,
    setToursData,
    setTourBookingsData,
    setEmployeesData,
    setSeasonalPricing,
    setIsLoading,
    setError,
  }
) => {
  try {
    setUpdatingCarId(carId);
    await cars.update(carId, data);
    await fetchData();
    setEditingCar(null);
  } catch (error) {
    console.error("Error updating car:", error);
    await Swal.fire({
      icon: "error",
      title: "Error",
      text: "Failed to update car details. Please try again.",
      confirmButtonColor: "#1e3a8a",
    });
  } finally {
    setUpdatingCarId(null);
  }
};
